<template>
  <div class="bottom-charts">
    <div class="bc-chart-item card-background mr-4">
      <ComponentSubtitle>
        <span class="sub-title">服务项目</span></ComponentSubtitle
      >
      <div class="mt-1">
        <el-table
          :data="priceList"
          ref="scrollTablePrice"
          style="width: 100%"
          class-name="table-name"
          height="370"
          :border="false"
          :show-header="false"
          :header-cell-style="{
            color: '#333',
            borderColor: '#e2c6c0',
          }"
          :cell-style="{ borderColor: '#e2c6c0' }"
          @mouseenter.native="autoScroll(true)"
          @mouseleave.native="autoScroll(false)"
          :row-style="{
            backgroundColor: 'transparent',
            borderColor: '#e2c6c0',
          }"
        >
          <el-table-column prop="">
            <template slot-scope="{ row }">
              <div>
                <!-- <div class="channel" style="width: 200px">
                  <el-tooltip
                    effect="dark"
                    :content="row.goodsName"
                    placement="top-start"
                  >
                    <b>【{{ row.goodsCategoryName }}】{{ row.goodsName }}</b>
                  </el-tooltip>
                </div> -->
                <b>【{{ row.goodsCategoryName }}】{{ row.goodsName }}</b>

                <div class="flex justify-between mt-2">
                  <div>
                    服务价格：¥{{ Number(row.sellingPrice / 100).toFixed(2) }}
                  </div>
                  <!-- <div>民政补贴：¥0</div> -->
                  <div>
                    <div
                      v-if="row.shops && row.shops[0] && row.shops[0].belongTo"
                      class="channel"
                    >
                      <el-tooltip
                        effect="dark"
                        :content="row.shops[0].name"
                        placement="top-start"
                      >
                        <span class="content"
                          >服务机构:{{ row.shops[0].name }}
                        </span>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- <dv-scroll-board
          :config="configTable"
          style="width: 500px; height: 320px; color: #333"
        /> -->
      </div>
      <!-- <div id="main" style="width: 400px; height: 260px"></div> -->
    </div>
    <!-- </dv-border-box-13> -->
    <!-- <dv-border-box-13 :color="[$color.borderColor, $color.borderColor]"> -->
    <div class="bc-chart-item card-background">
      <!-- <div class="bcci-header"></div> -->
      <ComponentSubtitle>
        <span class="sub-title">服务完成情况</span>
      </ComponentSubtitle>
      <CompletionStatusTable></CompletionStatusTable>
    </div>
    <!-- </dv-border-box-13> -->

    <!-- <dv-border-box-13 :color="[$color.borderColor, $color.borderColor]">
      <div class="bc-chart-item table">
        <div class="bcci-header">实时风险评估情况</div>
        <dv-scroll-board :config="config3" style="height: 260px" />
      </div>
    </dv-border-box-13> -->
  </div>
</template>

<script>
import LabelTag from "./LabelTag";
import * as echarts from "echarts";
import "echarts-wordcloud";
import { mapGetters } from "vuex";
import RightContainer1 from "../../view/interaction/components/RightContainer1.vue";
import CompletionStatusTable from "./CompletionStatusTable.vue";
export default {
  name: "BottomCharts",
  components: {
    LabelTag,
    RightContainer1,
    CompletionStatusTable,
  },
  computed: {
    ...mapGetters(["globalData"]),
  },
  watch: {
    globalData: {
      handler(n, o) {
        return;
      },
    },
  },

  data() {
    return {
      scrolltimer: "", // 自动滚动的定时任务
      status1: true,
      status2: true,
      // config2:
      configTable: {
        // header: ["列1", "列2", "列3"],
        data: [
          ["行1列1", "行1列2", "行1列3"],
          ["行2列1", "行2列2", "行2列3"],
          ["行3列1", "行3列2", "行3列3"],
          ["行4列1", "行4列2", "行4列3"],
          ["行5列1", "行5列2", "行5列3"],
          ["行6列1", "行6列2", "行6列3"],
          ["行7列1", "行7列2", "行7列3"],
          ["行8列1", "行8列2", "行8列3"],
          ["行9列1", "行9列2", "行9列3"],
          ["行10列1", "行10列2", "行10列3"],
        ],
        index: false,
        align: ["center"],
        oddRowBGC: "#fff",
        evenRowBGC: "#fff",
      },
      config: {
        waitTime: 1000000,
        data: [
          [
            "<div class='content'>革新社区21栋5单元69号沈光华，行动不便，日常饮食不能解决。</div>",
          ],
          ["33栋1单元王碧华婆婆有就近购药需求"],
          ["21栋3单元37号马文成轻度依赖，坐轮椅，行动不便，日常不能下楼活动"],
          [
            "21栋1单元16楼李朝元与李红娅父女都有轻微精神障碍，问卷过程全程在询问电视不能观看问题（属于生活有一些问题需解决）",
          ],
          [
            "21栋1单元16楼李朝元与李红娅父女都有轻微精神障碍，问卷过程全程在询问电视不能观看问题（属于生活有一些问题需解决）",
          ],
          [
            "21栋1单元16楼李朝元与李红娅父女都有轻微精神障碍，问卷过程全程在询问电视不能观看问题（属于生活有一些问题需解决）",
          ],
          [
            "21栋1单元16楼李朝元与李红娅父女都有轻微精神障碍，问卷过程全程在询问电视不能观看问题（属于生活有一些问题需解决）",
          ],
          [
            "21栋1单元16楼李朝元与李红娅父女都有轻微精神障碍，问卷过程全程在询问电视不能观看问题（属于生活有一些问题需解决）",
          ],
          [
            "21栋1单元16楼李朝元与李红娅父女都有轻微精神障碍，问卷过程全程在询问电视不能观看问题（属于生活有一些问题需解决）",
          ],
          [
            "21栋1单元16楼李朝元与李红娅父女都有轻微精神障碍，问卷过程全程在询问电视不能观看问题（属于生活有一些问题需解决）",
          ],
          [
            "21栋1单元16楼李朝元与李红娅父女都有轻微精神障碍，问卷过程全程在询问电视不能观看问题（属于生活有一些问题需解决）",
          ],
        ],
      },
      priceList: [
        {
          name: "助医",
          price: 200,
          subsidy: 50,
          channel: "义渡睿初",
        },
      ],
    };
  },
  methods: {
    getShopList() {
      this.$axios
        .get("/mcapi/mallService/mechanism/goods/list", {
          params: {
            pageSize: 100,
          },
        })
        .then((resp) => {
          this.priceList = resp.data.list;
        });
    },
    initChart(el, option) {
      var myChart = echarts.init(document.getElementById(el));
      myChart.setOption(option);
      if (el == "main") {
        myChart.on("click", (param) => {
          this.$router.push("/interaction");
        });
      }
    },
    formatAge(type = 0) {
      let sumList = [0, 0, 0, 0, 0];
      let sum1 = 0; // 小于50岁
      let sum2 = 0; // 50-60
      let sum3 = 0; // 60-70
      let sum4 = 0; // 70岁以上
      return;
      let userList = this.globalData["users"];
      userList.map((v) => {
        if (v.age > 14 && v.age < 50) {
          sumList[0] += 1;
        } else if (v.age >= 50 && v.age < 60) {
          sumList[1] += 1;
        } else if (v.age >= 60 && v.age < 70) {
          sumList[2] += 1;
        } else if (v.age <= 14) {
          sumList[4] += 1;
        } else {
          sumList[3] += 1;
        }
      });
      return sumList[type];
      console.log("sumList", sumList);
    },
    getList() {
      return new Promise((resolve) => {
        this.$axios
          .get("/articleService/open/module/paginate")
          .then(async (resp) => {
            let list = resp.data.list;
            if (list.length > 4) {
              list = list.slice(0, 4);
            }
            let titleData = [];

            for (let i = 0; i < list.length; i++) {
              let response = await this.getArticleList({
                moduleId: list[i].id,
              });
              response.list.map((v) => {
                titleData.push(v);
              });
            }
            resolve(titleData);
          });
      });
    },
    getArticleList(params) {
      return new Promise((resolve) => {
        this.$axios
          .get("/articleService/open/article/paginate", {
            params,
          })
          .then((resp) => {
            resolve(resp.data);
          });
      });
    },
    async initWordCloudy() {
      let titleData = await this.getList();
      titleData = titleData.map((v) => {
        return {
          name: v.title,
          value: Math.floor(Math.random() * (100 - 1 + 1)) + 1,
        };
      });
      console.log("titleData", titleData);
      let colorList = [
        "#ff9597",
        "#22cfe0",
        "#b9b1f0",
        "#51b7fb",
        "#76e68f",
        "#fa8b54",
        "#ffc545",
        "#ffd9a6",
      ];
      let option = {
        tooltip: {
          show: true,
        },
        series: [
          {
            type: "wordCloud", //词云图
            left: "0%", // X轴偏移量
            top: "0%", // Y轴偏移量
            width: "100%", // canvas宽度大小
            height: "100%", // canvas高度大小
            sizeRange: [12, 30], //  词典字体大小范围配置
            rotationRange: [0, 0], // 词典字体旋转角度配置，默认不旋转
            gridSize: 12, // 词典字体间距配置
            layoutAnimation: true, // 为false词典过度会阻塞
            textStyle: {
              fontFamily: "sans-serif",
              fontWeight: "bold",
              // Color可以是一个回调函数或一个颜色字符串
              color: function () {
                let index = Math.floor(Math.random() * colorList.length);
                return colorList[index];
              },
            },

            emphasis: {
              focus: "self",

              textStyle: {
                // textShadowBlur: 10,
                // textShadowColor: "#333",
              },
            },
            // color: ["#f00", "#0f0", "#00f"],
            layoutAnimation: true,
            data: titleData,
            // data: [
            //   // {
            //   //   name: "骨质疏松？可能并不只是因为老了而已！",
            //   //   value: 15,
            //   // },
            //   // {
            //   //   name: "可不能一“钙”而论！",
            //   //   value: 19,
            //   // },
            //   // {
            //   //   name: "总是膝盖关节痛腿痛？",
            //   //   value: 29,
            //   // },
            // ],
          },
        ],
      };
      return option;
    },

    // 设置自动滚动
    autoScroll(stop) {
      const table = this.$refs.scrollTablePrice;
      // 拿到表格中承载数据的div元素
      const divData = table.$refs.bodyWrapper;
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      if (stop) {
        //再通过事件监听，监听到 组件销毁 后，再执行关闭计时器。
        window.clearInterval(this.scrolltimer);
      } else {
        this.scrolltimer = window.setInterval(() => {
          // 元素自增距离顶部1像素
          divData.scrollTop += 1;
          // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
          if (
            parseInt(divData.clientHeight) + parseInt(divData.scrollTop) ==
            parseInt(divData.scrollHeight)
          ) {
            // 重置table距离顶部距离
            divData.scrollTop = 0;
            // 重置table距离顶部距离。值=(滚动到底部时，距离顶部的大小) - 整个高度/2
            // divData.scrollTop = divData.scrollTop - divData.scrollHeight / 2
          }
        }, 150); // 滚动速度
      }
    },
  },
  mounted() {
    this.getShopList();

    this.autoScroll();
  },
  beforeDestroy() {
    this.autoScroll(true);
  },
};
</script>

<style lang="less" scoped>
.channel {
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
// ::v-deep {
//   .el-table::before {
//     height: 0;
//   }
//   .el-table,
//   .el-table__body {
//     background: transparent !important;
//     color: @primary-color;
//     border: none;
//   }

//   .el-table th {
//     background-color: transparent !important;
//   }
//   .el-table tr {
//     background-color: transparent !important;
//   }
//   .el-table__body tr.hover-row > td {
//     background-color: #a5ccf2 !important;
//     border: none;
//   }
//   .el-table tbody tr:hover > td {
//     border: 1px solid #a5ccf2;

//     background-color: #a5ccf2 !important //修改成自己想要的颜色即可
// ;
//   }
// }
.content {
}
.bottom-charts {
  height: 440px;
  width: 100%;
  flex: 1;
  display: flex;
  position: relative;
  margin-top: 10px;
  .bc-chart-item {
    // width: 25%;
    // flex: 1;
    height: 100%;
    flex: 1;
    box-sizing: border-box;
    // background: #fff;
    padding: 6px;
  }

  .bcci-header {
    height: 50px;
    text-align: left;
    line-height: 50px;
    font-size: 20px;
    position: relative;
    text-indent: 30px;
  }
  .bcci-header::before {
    position: absolute;
    top: 10px;
    left: 0;
    content: " ";
    display: inline-block;
    height: 30px;
    width: 15px;
    background: #4bace0;
  }

  .dv-active-ring-chart {
    height: calc(~"100% - 80px");
  }

  .label-tag {
    height: 30px;
  }

  .active-ring-name {
    font-size: 18px !important;
  }

  .decoration-1,
  .decoration-2,
  .decoration-3 {
    display: absolute;
    left: 0%;
  }
  .table {
  }

  ::v-deep {
    .row-item {
      border-bottom: 1px solid @border-color !important;
    }
    .el-table,
    .el-table__expanded-cell {
      background: none;
    }

    .el-table {
      font-size: 17px;
    }
  }
}
</style>
